import { jsx as r, jsxs as p } from "react/jsx-runtime";
import * as e from "@radix-ui/react-select";
import { Check as g, ChevronDown as f } from "lucide-react";
import { forwardRef as c } from "react";
import { c as n } from "./cn-DlLpp5ix.js";
const u = e.Root, x = e.Group, S = e.Value, v = e.Portal, w = {
  sm: "h-8 px-2.5 text-sm",
  md: "h-10 px-3 text-sm",
  lg: "h-12 px-3.5 text-md"
}, y = c(
  function({ size: o = "md", invalid: t = !1, className: l, children: i, ...d }, m) {
    return /* @__PURE__ */ p(
      e.Trigger,
      {
        ref: m,
        className: n(
          "inline-flex w-full items-center justify-between gap-2 rounded-lg border bg-bg-base text-primary outline-none transition-colors",
          "focus-visible:shadow-ring-focus disabled:cursor-not-allowed disabled:opacity-60",
          "data-[placeholder]:text-tertiary",
          w[o],
          t ? "border-error-border focus-visible:border-error" : "border-default hover:border-strong focus-visible:border-accent",
          l
        ),
        "aria-invalid": t || void 0,
        ...d,
        children: [
          i,
          /* @__PURE__ */ r(e.Icon, { asChild: !0, children: /* @__PURE__ */ r(
            f,
            {
              "aria-hidden": "true",
              width: 16,
              height: 16,
              strokeWidth: 1.75,
              className: "text-tertiary"
            }
          ) })
        ]
      }
    );
  }
), I = c(
  function({ className: o, children: t, position: l = "popper", sideOffset: i = 6, layer: d = "popover", style: m, ...h }, b) {
    return /* @__PURE__ */ r(
      e.Content,
      {
        ref: b,
        position: l,
        sideOffset: i,
        className: n(
          "z-popover overflow-hidden rounded-xl border border-default bg-bg-elevated shadow-lg",
          "min-w-[var(--radix-select-trigger-width)] max-h-[var(--radix-select-content-available-height)]",
          o
        ),
        style: {
          ...d === "modal" ? { zIndex: "calc(var(--z-modal) + 1)" } : null,
          ...m
        },
        ...h,
        children: /* @__PURE__ */ r(e.Viewport, { className: "p-1", children: t })
      }
    );
  }
), N = c(
  function({ className: o, children: t, ...l }, i) {
    return /* @__PURE__ */ p(
      e.Item,
      {
        ref: i,
        className: n(
          "relative flex cursor-default select-none items-center justify-between gap-2 rounded-md px-2.5 py-2 text-sm text-primary outline-none",
          "data-[highlighted]:bg-bg-hover data-[state=checked]:text-accent",
          "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-60",
          o
        ),
        ...l,
        children: [
          /* @__PURE__ */ r(e.ItemText, { children: t }),
          /* @__PURE__ */ r(e.ItemIndicator, { children: /* @__PURE__ */ r(g, { "aria-hidden": "true", width: 14, height: 14, strokeWidth: 2.5 }) })
        ]
      }
    );
  }
), C = c(function({ className: o, ...t }, l) {
  return /* @__PURE__ */ r(
    e.Label,
    {
      ref: l,
      className: n(
        "px-2.5 py-1.5 text-2xs font-semibold uppercase tracking-uppercase text-tertiary",
        o
      ),
      ...t
    }
  );
}), T = c(function({ className: o, ...t }, l) {
  return /* @__PURE__ */ r(
    e.Separator,
    {
      ref: l,
      className: n("my-1 h-px bg-default", o),
      ...t
    }
  );
}), a = ((s) => /* @__PURE__ */ r(u, { ...s }));
a.Root = u;
a.Trigger = y;
a.Value = S;
a.Content = I;
a.Portal = v;
a.Item = N;
a.Group = x;
a.Label = C;
a.Separator = T;
a.displayName = "Select";
export {
  a as S,
  I as a,
  x as b,
  N as c,
  C as d,
  v as e,
  u as f,
  T as g,
  y as h,
  S as i
};
//# sourceMappingURL=Select-DOSgnQSf.js.map
